export enum TERMS_AND_CONDITIONS_STATUS {
  READ = 'read',
  ACCEPTED = 'accepted',
  CANCELLED = 'cancelled',
}
